import React, { useState, useEffect, useReducer } from "react";
import { Row, Col, Card, Typography, Button, message, Divider, Tooltip, Form, Modal, Select, Space } from "antd";
import {
  EditOutlined,
  ScheduleOutlined,
  PlusOutlined,
  DeleteOutlined,
  UnorderedListOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import { TableCustom } from "../../../components/table";
import { reducerRegister } from "../../../helpers/reducers";
const { Text } = Typography;

export const EleicoesCipaEleicoesLocalidades = ({ to }) => {
  const navigate = useNavigate();
  const { id_eleicoes } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, dispatch] = useReducer(reducerRegister, []);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // FORMULÁRIOS
  const [eleicao, setEleicao] = useState({});
  const [localidades, setLocalidades] = useState([]);

  useEffect(() => {
    if (id_eleicoes) {
      carregarEleicao(id_eleicoes);
      listarLocalidades(id_eleicoes);
      listarEleicoesLocalidades(id_eleicoes);
    }
  }, [id_eleicoes]);

  // CARREGAR ELEIÇÃO
  const carregarEleicao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_eleicoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (api?.response?.data) setEleicao(api.response.data);
    } else {
      message.error(api.response.message);
      navigate(to);
    }
    setLoading(false);
  };

  // LISTAR LOCALIDADES
  const listarLocalidades = async (id) => {
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_eleicoes_localidades/listar_localidades/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      let array_localidades = [];
      if (response?.length > 0) {
        for (let local of response) {
          array_localidades.push({ label: local.descricao, value: local.id });
        }
      }
      setLocalidades(array_localidades);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarEleicoesLocalidades = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_eleicoes_localidades/listar/${id}`, []);
    if (api.statusCode === 200) {
      dispatch({ type: "LOAD", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarEleicoesLocalidades = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/eleicoes_cipa_eleicoes_localidades/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarEleicoesLocalidades(id_eleicoes);
      listarLocalidades(id_eleicoes);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarEleicoesLocalidades = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/eleicoes_cipa_eleicoes_localidades/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      dispatch({ type: "DELETE", payload: { id: id } });
      listarLocalidades(id_eleicoes);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Localidade",
      dataIndex: "localidade",
    },
    {
      title: "Candidatos",
      width: 40,
      dataIndex: "total_candidatos",
      render: (_, e) => <Text type={e?.total_candidatos > 0 ? "" : "danger"}>{e?.total_candidatos}</Text>,
    },
    {
      title: "Ações",
      sorter: false,
      width: 50,
      render: (_, e) => {
        return (
          <Space.Compact>
            <Tooltip title="Candidatos">
              <Button
                loading={loading}
                onClick={() => navigate(`/eleicoes-cipa/eleicoes/localidades/${id_eleicoes}/candidatos/${e.id}`)}
                icon={<TeamOutlined />}
              />
            </Tooltip>

            {eleicao?.status_gerado === 0 && eleicao?.status === -1 && (
              <Tooltip title="Excluir">
                <Button
                  danger
                  loading={loading}
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    modal.confirm({
                      title: "Deseja deletar este registro?",
                      okText: "Sim",
                      cancelText: "Cancelar",
                      onOk() {
                        deletarEleicoesLocalidades(e.id);
                      },
                    });
                  }}
                />
              </Tooltip>
            )}
          </Space.Compact>
        );
      },
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.id_eleicoes = id_eleicoes;
    cadastrarEleicoesLocalidades(formulario);
  };

  // FORMULÁRIO
  const modalFormulario = (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> Vincular Localidade
        </Text>
      }
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={800}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        resetForm();
      }}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={24}>
            <Form.Item
              name="id_cad_localidades"
              label="Localidade"
              rules={[{ required: true, message: "Selecione a localidade!" }]}>
              <Select
                size="large"
                placeholder="Selecione a localidade"
                disabled={loading}
                style={{ width: "100%" }}
                options={localidades}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Eleições CIPA" onClickBack={() => navigate(to)} />
            <HeaderTitle
              title={["Eleições", "Localidades"]}
              subtitle={
                <Text italic>
                  <ScheduleOutlined /> {eleicao?.descricao ?? ""}
                </Text>
              }
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  eleicao?.status_gerado === 0 &&
                  eleicao?.status === -1 && (
                    <Tooltip title="Adicionar Registro">
                      <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => {
                          setShowModal(true);
                          resetForm();
                        }}
                        loading={loading}>
                        Novo
                      </Button>
                    </Tooltip>
                  )
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
